<template>
  <div class="page-wrapper scrollable -x -y">
    <div class="page">
      <div v-if="errMessage" class="message">
        <h1>ERROR</h1>
        <p>{{errMessage}}</p>
        <p>
          <a v-on:click="goToLogin()" ontouchstart=""
          class="text-btn">
            Try login again
          </a>
        </p>
      </div>
      <div v-else class="my-spinner">
        <comp-icon
        v-bind:icon="'spinnerPuff'"
        v-bind:width="60"></comp-icon>
      </div>
    </div>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'my-callback',
  components: {
    CompIcon
  },
  data: function () {
    return {
      errMessage: null,
      retryMax: 3,
      curCount: 0
    }
  },
  created: function () {
    this.handleAuthentication()
  },
  methods: {
    handleAuthentication: function () {
      this.$store.dispatch('handleAuthentication').then(
        success => {
          this.$logger.info('handleAuthentication: Authenticated user')
          // do nothing
          // there is the event listener in MyAuth.vue
        },
        err => {
          try {
            if (err.message === 'no_result') {
              this.curCount++
              if (this.retryMax !== this.curCount) {
                setTimeout(() => this.handleAuthentication(), 100)
              } else {
                this.$logger.error('handleAuthentication: Not authenticated user: ' + err.message)
                this.errMessage = 'Login failed: No id_token'
              }
              return
            }
          } catch (error) {}
          let errMessage = JSON.stringify(err)
          this.$logger.error('handleAuthentication: Not authenticated user: ' + errMessage)
          this.errMessage = errMessage
          // do nothing
        }
      )
    },
    goToLogin: function () {
      this.$tool.redirectToUrl(window.origin)
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: relative;
}

.page {
  /* common */
  font-size: 13px;
  background-color: #fefefe;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* alignment */
  display: table;
}

.my-spinner {
  /* common */
  color: #fefefe;
  /* size */
  width: 100%;
  height: 100%;
  /* alignment */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.page .message {
  /* common */
  color: #fefefe;
  font-size: 26px;
  /* text */
  word-break: break-word;
  /* size */
  padding: 1em;
  /* alignment */
  display: table-cell;
  vertical-align: middle;
}

.page .text-btn {
  /* mouse */
  cursor: pointer;
}
.page .text-btn:hover {
  /* common */
  color: hsla(202, 100%, 40%, 1);
}

</style>



// WEBPACK FOOTER //
// src/pages/MyCallback.vue